import { render, staticRenderFns } from "./TheAppDrawer.vue?vue&type=template&id=564d360a"
import script from "./TheAppDrawer.vue?vue&type=script&lang=js"
export * from "./TheAppDrawer.vue?vue&type=script&lang=js"
import style0 from "./TheAppDrawer.vue?vue&type=style&index=0&id=564d360a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports